{
  "auth": {
    "mfa": {
      "title": "Two-step verification",
      "description": "Enter the six-digit code from your authenticator app.",
      "code": "Verification code",
      "submit": "Verify",
      "cancel": "Back to sign in",
      "invalid": "Enter a valid six-digit code.",
      "error": "The verification code could not be accepted.",
      "unsupported": "This account uses an unsupported MFA method.",
      "revert": {
        "title": "Remove two-step verification?",
        "description": "This will remove {{factor}} from your account. Only continue if you requested this change.",
        "confirmation": "I want to remove this authenticator.",
        "submit": "Remove authenticator",
        "success": {
          "title": "Authenticator removed",
          "description": "The authenticator was removed from your account.",
          "signIn": "Continue to sign in"
        },
        "error": {
          "title": "Link expired or already used",
          "description": "The authenticator was not removed. You'll still need a code from it to sign in — contact support if you no longer have access to it.",
          "signIn": "Return to sign in"
        }
      }
    }
  },
  "signin": {
    "title": "Sign in to your account",
    "email": {
      "required": "Email is required.",
      "invalid": "Please enter a valid email address.",
      "title": "Email"
    },
    "password": {
      "required": "Password is required.",
      "minLength": "Password must be at least 6 characters.",
      "title": "Password",
      "forgot": "Forgot password?",
      "aria": "Toggle password visibility"
    },
    "submit": "Sign In",
    "info": {
      "title": "Don't have an account yet?",
      "learn": "Learn more"
    }
  },
  "forgotpassword": {
    "title": "Reset Password",
    "description": "Enter your email address to reset your password",
    "email": {
      "title": "Email Address",
      "required": "Email is required",
      "invalid": "Enter a valid email"
    },
    "submit": "Reset Password",
    "backtosignin": "Back to Sign In",
    "success": "Password reset email sent. Check your inbox."
  },
  "passwordreset": {
    "title": "Password Reset",
    "description": "Please enter your new password.",
    "email": {
      "title": "Email"
    },
    "password": {
      "title": "New Password",
      "required": "Password is required",
      "complexity": "Password doesn't meet the requirements.",
      "repeat": {
        "title": "Repeat New Password",
        "required": "Please confirm your password",
        "match": "Passwords must match."
      }
    },
    "submit": "Reset Password",
    "continue": "Continue",
    "backtosignin": "Back to Sign In",
    "success": "Your password has been successfully reset.",
    "invalid": {
      "password": "Your password is invalid or the password reset code is expired.",
      "code": "The password reset code is invalid or has expired."
    }
  },
  "verifyemail": {
    "title": "Email verification",
    "description": "Please enter your new password.",
    "subdescription": "It must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
    "password": {
      "title": "New Password",
      "required": "Password is required",
      "complexity": "Password doesn't meet the requirements.",
      "repeat": {
        "title": "Repeat New Password",
        "required": "Please confirm your password",
        "match": "Passwords must match."
      }
    },
    "unknownerror": "An unknown error occurred during email verification.",
    "submit": "Reset Password",
    "continue": "Continue",
    "backtosignin": "Back to Sign In",
    "success": "Your email has been successfully verified.",
    "successreset": "Your password has been successfully set.",
    "invalid": {
      "password": "Your password is invalid.",
      "code": "The password reset code is invalid or has expired."
    }
  },
  "autherror": {
    "user": {
      "notfound": "No account found with this email.",
      "disabled": "This account has been disabled."
    },
    "invalid": {
      "password": "Invalid email or password.",
      "credential": "Invalid email or password.",
      "email": "Invalid email address.",
      "actioncode": "Email address verification failed",
      "reqtype": "Email address verification failed"
    },
    "request": {
      "toomany": "Too many attempts. Please try again later."
    },
    "expired": {
      "oobcode": "Link expired"
    },
    "default": "An error occurred. Please try again."
  },
  "lang": "FR",
  "redirect": {
    "title": "Redirecting...",
    "subtitle": "Signed in as"
  }
}
